import { makeActionCreator } from '../../../core/types/redux';
import {
  LoginActionConstants as C,
  RequestLoginArgs,
  SetLoginArgs,
  SetLoginSessionArgs,
} from './types';

const create = makeActionCreator<C>();

export const initialize = create(C.INITIALIZE);
export const requestLoginSession = create<unknown>(C.LOGIN_SESSION_REQUEST);
export const setLoginSession = create<SetLoginSessionArgs>(C.LOGIN_SESSION_SET);
export const requestLogin = create<RequestLoginArgs>(C.LOGIN_REQUEST);
export const setLogin = create<SetLoginArgs>(C.LOGIN_SET);
